import { Component, inject, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { SelectableString } from '@app/component/autocomplete/string-autocomplete/selectable-string';
import { ComponentModule } from '@app/component/component.module';
import { SurveyListFilterState } from '@app/component/survey-list-filter/survey-list-filter-state';
import { SearchField } from '@core/base/objects/search/search-field';
import { BeneficiaryGroup } from '@shared/beneficiary/beneficiary-group';
import { BeneficiaryGroupApi } from '@shared/beneficiary/beneficiary-group-api.service';
import { Enum } from '@shared/enum/enum';
import { EnumApi } from '@shared/enum/enum-api.service';
import { Questionnaire } from '@shared/questionnaire/questionnaire';
import { QuestionnaireApi } from '@shared/questionnaire/questionnaire-api.service';
import { SurveyApi } from '@shared/survey/survey-api.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-survey-search-widget',
  templateUrl: './survey-search-widget.component.html',
  styleUrls: ['./survey-search-widget.component.scss'],
  imports: [ComponentModule],
})
export class SurveySearchWidgetComponent implements OnInit {
  dataLoaded = signal<boolean>(false);

  questionnaires: Questionnaire[] = [];
  groups: BeneficiaryGroup[] = [];
  surveyPlatforms: Enum[] = [];
  questionnaireFormTypes: Enum[] = [];
  rounds: SelectableString[] = [];
  surveyStatuses: Enum[] = [];

  private readonly router = inject(Router);
  private readonly questionnaireApi = inject(QuestionnaireApi);
  private readonly beneficiaryGroupApi = inject(BeneficiaryGroupApi);
  private readonly enumApi = inject(EnumApi);
  private readonly surveyApi = inject(SurveyApi);

  ngOnInit(): void {
    forkJoin({
      questionnaires: this.questionnaireApi.findAll(),
      groups: this.beneficiaryGroupApi.findAll(),
      surveyPlatforms: this.enumApi.getSurveyPlatforms(),
      questionnaireFormTypes: this.enumApi.getQuestionnaireFormTypes(),
      rounds: this.surveyApi.getRounds(),
      statuses: this.enumApi.getSurveyStatuses(),
    }).subscribe(results => {
      this.questionnaires = results.questionnaires;
      this.groups = results.groups;
      this.surveyPlatforms = results.surveyPlatforms;
      this.questionnaireFormTypes = results.questionnaireFormTypes;
      this.rounds = results.rounds.map((round: string, index: number) => ({
        value: round,
        uuid: index.toString(),
        selected: false,
      }));
      this.surveyStatuses = results.statuses;

      this.dataLoaded.set(true);
    });
  }

  search(surveyFilter: SearchField[]): void {
    const state: SurveyListFilterState = {
      surveyFilter,
    };

    this.router.navigate(['/surveys'], { state });
  }
}
